import React from 'react';
import './Form.css'; // Reusing existing styles

const Impressum = () => {
  return (
    <div className="form-container">
      <h1>Impressum</h1>
      <div className="impressum-content">
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          Gerald Fehringer<br />
          Lilienstraße 11, <br />
          D-20095 Hamburg
        </p>

        <h2>Kontakt</h2>
        <p>
          E-Mail: support@hificouch.world
        </p>

        <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
        <p>
          Gerald Fehringer<br />
          Lilienstraße 11, <br />
          D-20095 Hamburg
        </p>

        <h2>Datenschutz</h2>
        <p>
          Diese Webseite ist ein Open Source Community-Projekt. Wir verwenden keine Webseiten-Analytics oder sonstige Tracking-Tools.
          Die bei der Registrierung angegebenen Benutzerdaten werden ausschließlich lokal auf unserem Server in Deutschland gespeichert
          und nur zur Bereitstellung der technischen Funktionalität dieser Plattform verwendet.
        </p>
        <p>
          Ihre Daten werden zu keinem Zeitpunkt an Dritte weitergegeben und nicht für Marketingzwecke verwendet.
          Die Plattform ist ausschließlich für Privatanwender konzipiert.
        </p>

        <h2>Haftungsausschluss</h2>
        <p>
          Die Inhalte dieser Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
          können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
          nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
          übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>
      </div>
    </div>
  );
};

export default Impressum;